// extracted by mini-css-extract-plugin
module.exports = {"thumb":"thumb-hashed__thumb__1UQOl","thumbNoIcon":"thumb-hashed__thumbNoIcon__3CDr8","thumbDetails":"thumb-hashed__thumbDetails__1oHYr","icon":"thumb-hashed__icon__2CXVw"};